import { render, staticRenderFns } from "./LinkToMp.vue?vue&type=template&id=0978758b&scoped=true&"
import script from "./LinkToMp.vue?vue&type=script&lang=js&"
export * from "./LinkToMp.vue?vue&type=script&lang=js&"
import style0 from "./LinkToMp.vue?vue&type=style&index=0&id=0978758b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978758b",
  null
  
)

component.options.__file = "LinkToMp.vue"
export default component.exports